export function isSafariDesktop(): boolean {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;
    // Verifica si el navegador es Safari y si está en una plataforma de escritorio (no móvil)
    return /Safari/.test(userAgent) && !/Chrome/.test(userAgent) && /AppleWebKit/.test(userAgent) && !/Mobile/.test(userAgent) && (platform === 'MacIntel' || platform === 'Win32' || platform === 'Linux x86_64');
}